import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Form, Select, InputNumber, message, Button } from "antd";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import CloseButton from "../../Common/CloseButton/CloseButton";
import "./index.css";

const { Option } = Select;
const { createNewReservationTable } = restaurantSchemaActions;

const SHAPE_OPTIONS = [
  { label: "Кръгла", value: 1, cssClass: "round" },
  { label: "Квадратна", value: 2, cssClass: "square" },
  { label: "Правоъгълна", value: 3, cssClass: "rect" },
];

const CreateTableModal = ({
  openCreateTableModal,
  setOpenCreateTableModal,
  regionId,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedShape, setSelectedShape] = useState(null);
  const [seatsCount, setSeatsCount] = useState(null);

  const { touchSaleTablesPerRegion } = useSelector(
    (state) => state.restaurantSchemaReducer
  );

  const handleAddTable = () => {
    if (!selectedShape) {
      message.warning("Моля изберете форма на масата");
      return;
    }
    if (!seatsCount || seatsCount < 1) {
      message.warning("Моля въведете брой места");
      return;
    }
    form.validateFields().then((values) => {
      const tableName = touchSaleTablesPerRegion.filter(
        (table) => table.id === values.originalTouchSaleTables
      )[0].name;

      dispatch(
        createNewReservationTable({
          tableName: tableName,
          touchSaleTableId: values.originalTouchSaleTables,
          regionId: regionId,
          x: 650,
          y: 325,
          direction: 0,
          scale: 1.0,
          shape: selectedShape,
          seatsCount: seatsCount,
          organizationId: parseInt(localStorage.getItem("organizationId")),
        })
      );

      setOpenCreateTableModal(false);
      setSelectedShape(null);
      setSeatsCount(null);
      message.success("Успешно добавена маса");
      form.resetFields();
    });
  };

  const handleCancel = () => {
    setOpenCreateTableModal(false);
    setSelectedShape(null);
    setSeatsCount(null);
    form.resetFields();
  };

  return (
    <Modal
      closeIcon={<CloseButton />}
      title="Добави Маса"
      open={openCreateTableModal}
      onOk={handleAddTable}
      onCancel={handleCancel}
      footer={null}
      className="restaurant-scheme-table-modal"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="originalTouchSaleTables"
          label="Номер на масата"
          rules={[{ required: true, message: "Моля изберете име на масата." }]}
        >
          <Select
            showSearch
            virtual={false}
            placeholder="Маса"
            placement="topLeft"
            className="restaurant-scheme-table-modal-select ant-select-selection-search-input"
            filterOption={(input, option) =>
              option.children
                .toString()
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {touchSaleTablesPerRegion.map((table, index) => {
              let label = table.name;
              if (table.restaurantName) label += ` (${table.restaurantName})`;
              if (table.placesPos) label += ` - ${table.placesPos} места`;
              return (
                <Option
                  key={`${table.id}-${index}`}
                  value={table.id}
                  className="restaurant-scheme-table-modal-option"
                >
                  {label}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </Form>

      <div className="create-modal-shape-label">Форма на масата</div>
      <div className="create-modal-shape-grid">
        {SHAPE_OPTIONS.map((s) => (
          <div
            key={s.value}
            className={`create-modal-shape-card ${selectedShape === s.value ? "selected" : ""}`}
            onClick={() => setSelectedShape(s.value)}
          >
            <div className="create-modal-shape-card-preview">
              <div
                className={`create-modal-shape-preview ${s.cssClass}`}
                style={{
                  width: s.cssClass === "rect" ? 52 : 36,
                  height: 36,
                }}
              >
                {seatsCount && selectedShape === s.value ? (
                  <span className="create-modal-shape-preview-seats">
                    {seatsCount}
                  </span>
                ) : null}
              </div>
            </div>
            <span className="create-modal-shape-card-name">{s.label}</span>
          </div>
        ))}
      </div>

      <div className="create-modal-shape-label">Брой места</div>
      <InputNumber
        min={1}
        max={30}
        value={seatsCount}
        onChange={(val) => setSeatsCount(val)}
        placeholder="Брой места"
        style={{ width: "100%", marginBottom: 16 }}
      />

      <div className="restaurant-scheme-edit-table-modal-footer">
        <Button
          type="primary"
          onClick={handleAddTable}
          disabled={!selectedShape || !seatsCount}
        >
          Добави Маса
        </Button>
      </div>
    </Modal>
  );
};

export default CreateTableModal;
